module.exports = __webpack_public_path__ + "static/media/password.50aaad03.jpg";